import { FACTORYEXPORT_FREQUENCY } from "models";

import type { DropdownItemProps } from "components";
import type { TFunction } from "i18next";
import type { FactoryExport } from "models";

export const DEFAULT_EMAIL_SUBJECT = "Claire report {{.ReportName}} from {{.StartDate}} to {{.EndDate}}";
export const DEFAULT_EMAIL_MESSAGE = "Attached is the report {{.ReportName}} for the period {{.StartDate}}  - {{.EndDate}}";

const WEEK_DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const getWeekDayOptions = (t: TFunction): DropdownItemProps[] =>
  WEEK_DAYS.map((day, idx) => ({ key: idx + 1, value: idx + 1, text: t(`v8_${day.toLowerCase()}`, day) }));

const getWeekDayName = (day: number, t: TFunction) => getWeekDayOptions(t).find(option => option.value === day)?.text ?? "";

export const getExportDayName = ({ frequency, day }: Pick<FactoryExport, "frequency" | "day">, t: TFunction) => {
  if (frequency === FACTORYEXPORT_FREQUENCY.EveryDay) return "";
  if (frequency === FACTORYEXPORT_FREQUENCY.EveryMonth) return day;

  return getWeekDayName(day, t);
};
